export default __webpack_public_path__ + "images/b603b606fbbfba63ef2f66baafbbdbf9.png";